import { axios } from '@/utils/axios'

// 验证验证码
export async function checkSmsCode (params) {
  try {
    return await axios.get('/api/invoice/checkSmsCode', { params: { ...params } })
  } catch (error) {
    return Promise.reject(error)
  }
}

// 查询
export async function queryInvoiceList (params) {
  try {
    return await axios.post('/api/invoice/queryInvoiceList', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 开票
export async function invoicing (params) {
  try {
    return await axios.post('/api/invoice/invoicing', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 获取查询类型
export async function getCertTypes (params = {}) {
  try {
    return await axios.post('/api/invoice/getCertTypes', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 机票验真查询
export async function queryTicketInfo (params = {}) {
  try {
    return await axios.post('/api/rest/queryTicketInfo', params)
  } catch (error) {
    return Promise.reject(error)
  }
}
